import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";

import { useNavigate } from "react-router-dom";

import { useMutation } from "graphql-hooks";

import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import AlertDialog from "../../components/AlertDialog.js";

import {EDIT_TEAM_TERM} from "../../graphQL/team_term_qry";

const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },

  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 20,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginLeft: 5,
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
  textFieldInput: {    
    resize: "both",
    height: "150px",
    maxHeight: "200px",
    width: "500px",
    maxWidth: "550px"
  },
}));

export default function EditTeamGoalDialog({
  currentTeamTerm, 
  teamGoal, 
  closeDialog,
  handleDone
}) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState({
    teamTermGoal: ""
  });

  const maxChar = 254;
  const [teamTermGoal, setTeamTermGoal] = useState(teamGoal);
  const [editedTeamTermGoal, setEditedTeamTermGoal] = useState(teamGoal);
  const [remainedChars, setRemainedChars] = useState(null);

  const [editTeamTerm] = useMutation(EDIT_TEAM_TERM, {
    awaitRefetchQueries: true,
  });

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  const handleTeamTermGoalChange = event => {
    if (event.target.value.trim() === "")
      setErrorMsg({ teamTermGoal: "Team Term Goal cannot be blank." });
    else setErrorMsg({ teamTermGoal: "" });
    setTeamTermGoal(event.target.value);
    updRemainedChars(event.target.value)
  };  

  const handleSave = async () => {
    if (teamTermGoal.trim() === "") {
      setErrorMsg({ teamTermGoal: "Team Term Goal cannot be blank." });    
    } else {
      if (currentTeamTerm && currentTeamTerm.teamTermId) {
        const { data, error } = await editTeamTerm({
          variables: {
            teamTermId: parseInt(currentTeamTerm.teamTermId),
            goal: teamTermGoal, 
          },
        });
        if (error) {
          console.log("Error:",error)
        } else if (data && data.editTeamTerm) {
          console.log("Succes:",data.editTeamTerm)
          setTeamTermGoal(data.editTeamTerm.teamTerm.goal);
          setEditedTeamTermGoal(data.editTeamTerm.teamTerm.goal);
          handleDone(data.editTeamTerm.teamTerm.goal);         
        };
      }      
      else handleDone(teamTermGoal);
      handleClose();
    };
  };

  const updRemainedChars = (input) => {
    maxChar !== "" && setRemainedChars(maxChar - input.length)
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              height: "100%",
              maxWidth: "600px",
              maxHeight: "450px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: 0,
          }}
        >
          <Box mt={1} ml={1}>
            Team Term Goal
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: theme => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>      

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Box style={{ width: "fit-content" }}>
              <TextField
                id="teamTermGoal"
                variant="outlined"
                multiline
                fullWidth
                autoFocus
                required
                label="Team Term Goal"
                margin="normal"
                name="teamTermGoal"
                rows={4}
                className={classes.textFieldStyle}
                defaultValue={teamTermGoal}
                inputProps={{
                  maxLength: 254,
                }}
                InputProps={{
                  classes: {
                    input: classes.textFieldInput
                  },
                }}
                onChange={handleTeamTermGoalChange}
              />
            </Box>
            {errorMsg && (
              <FormHelperText className={classes.errorStyle} error>
                {errorMsg.teamTermGoal}
              </FormHelperText>
            )}
            <Typography
              variant="h6"
              style={{
                display: "flex",
                alignItems: "center",
                paddingRight: 5,
                paddingTop: 5,
                color: "#00000099",
              }}
            >
              {(remainedChars !== null && remainedChars > 0)
                ? remainedChars +
                  " of " + maxChar + " Character(s) left"
                : teamTermGoal && teamTermGoal.length &&
                  teamTermGoal.length <= parseInt(maxChar)
                  ? maxChar - teamTermGoal.length + " of " + 
                    maxChar + " Character(s) left"
                  : maxChar + " of " + maxChar + " Character(s) left"
              }
            </Typography>            
          </DialogContentText>
        </DialogContent>

        <DialogActions style={{ justifyContent: "center", marginTop: 15 }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={handleSave}
            >
              Done
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>      
    </div>
  );
}
